import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{attrs:{"color":_vm.chipColor,"text-color":_vm.textColor}},[_vm._v(_vm._s(this.status))])
}
var staticRenderFns = []

export { render, staticRenderFns }